import { useEffect, useMemo, useState } from 'react';
import { archiveRepository } from '../db/gcam-db';
import { useAppStore } from '../app/store/useAppStore';
import { BottomNav } from '../components/navigation/BottomNav';
import { Icon } from '../components/ui/Icon';
import type { EncounterRecord } from '../types';

function ArchiveRow({ record, onOpen }: { record: EncounterRecord; onOpen: () => void }) {
  const url = useMemo(() => URL.createObjectURL(record.photoBlob), [record.photoBlob]);
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  const date = new Date(record.createdAt);
  return <button className="archive-row" onClick={onOpen}>
    <img src={url} alt=""/><span className="archive-row-copy"><strong>{record.id}</strong><small>{date.toLocaleDateString('zh-TW')}　{date.toLocaleTimeString('zh-TW', { hour: '2-digit', minute: '2-digit', hour12: false })}</small><em>{record.people.map((person) => person.label).join(' × ')}</em></span><span className="mini-palette">{record.palette.slice(0, 4).map((color) => <i key={color.hex} style={{ background: color.hex }}/>)}</span><Icon name="arrow" size={18}/>
  </button>;
}

export function ArchivePage() {
  const [records, setRecords] = useState<EncounterRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useAppStore((state) => state.navigate);
  const select = useAppStore((state) => state.selectEncounter);
  useEffect(() => { void archiveRepository.list().then(setRecords).finally(() => setLoading(false)); }, []);
  return <main className="screen archive-screen with-bottom-nav">
    <header className="page-header"><div><span className="micro-label">LOCAL ENCOUNTERS</span><h1>相簿</h1></div><b className="focus-mark">[•]</b></header>
    <section className="archive-profile-rail"><div className="profile-avatar">L</div><div><strong>LUN</strong><small>INTERACTIVE DESIGNER</small></div><span><small>相遇次數</small>{records.length.toString().padStart(3, '0')}</span><button aria-label="前往個人介紹" onClick={() => navigate('PROFILE')}><Icon name="arrow"/></button></section>
    <div className="archive-toolbar"><span>全部相遇</span><span className="mono">最新排序　{records.length}</span></div>
    <section className="archive-list" aria-live="polite">
      {loading ? <div className="archive-empty"><span className="spinner"/><p>讀取本機相簿</p></div> : null}
      {!loading && records.length === 0 ? <div className="archive-empty"><Icon name="archive" size={42}/><h2>尚無相遇紀錄</h2><p>完成第一次拍照並保存後，作品會只留在這台裝置。</p><button className="outline-button accent-border" onClick={() => navigate('CAMERA_INIT')}>開始拍照</button></div> : null}
      {records.map((record) => <ArchiveRow key={record.id} record={record} onOpen={() => { select(record.id); navigate('ARCHIVE_DETAIL'); }}/>) }
    </section>
    <p className="privacy-note archive-privacy">照片、座標與簽名僅保存在此裝置，不會自動上傳。</p>
    <BottomNav active="archive"/>
  </main>;
}
